class CartDrawerUpsell extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    const btn = event.target.closest('.cart-drawer-upsell__add-btn');
    if (!btn || btn.disabled) return;

    event.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add('cart-drawer-upsell__add-btn--loading');

    const body = JSON.stringify({
      items: [{ id: parseInt(variantId, 10), quantity: 1 }],
      sections: this.getSectionsToRender().map((s) => s.id),
      sections_url: window.location.pathname,
    });

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          // Error (e.g. out of stock)
          btn.disabled = false;
          btn.classList.remove('cart-drawer-upsell__add-btn--loading');
          return;
        }

        // Re-render cart drawer sections from server response
        this.getSectionsToRender().forEach((section) => {
          const el = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          if (!el || !data.sections[section.id]) return;

          const html = new DOMParser().parseFromString(data.sections[section.id], 'text/html');
          const source = section.selector ? html.querySelector(section.selector) : html.getElementById(section.id);
          if (source) el.innerHTML = source.innerHTML;
        });

        // Re-bind the overlay close listener (gets wiped on innerHTML replace)
        const overlay = document.getElementById('CartDrawer-Overlay');
        const drawer = document.querySelector('cart-drawer');
        if (overlay && drawer) {
          overlay.addEventListener('click', () => drawer.close());
        }

        // Publish cart update so other components (icon bubble, etc.) stay in sync
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-drawer-upsell',
            cartData: data,
          });
        }
      })
      .catch((err) => {
        console.error('Cart drawer upsell error:', err);
        btn.disabled = false;
        btn.classList.remove('cart-drawer-upsell__add-btn--loading');
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }
}

customElements.define('cart-drawer-upsell', CartDrawerUpsell);
